import type { ReactNode } from 'react';

export const symbol_music_note_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M124.5-163.5Q81-207 81-270t43.5-106.5Q168-420 231-420q28 0 50.5 8t39.5 22v-345q0-11 7-19t18-10l419-70q14-2 24.5 6.5T800-805v455q0 63-43.5 106.5T650-200q-63 0-106.5-43.5T500-350q0-63 43.5-106.5T650-500q28 0 50.5 8t39.5 22v-184l-359 60v324q0 63-43.5 106.5T231-120q-63 0-106.5-43.5Z"
		/>
	</svg>
);
